import { defineNuxtPlugin } from "#app";

export const sourceData = [
  {
    //0: Youtube
    name: "Youtube",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:(?:watch|live)?\?(?:.*&)?v(?:i)?=|(?:embed|v|vi|user|shorts|live)\/))([^\?&\"'>]+)(?:(?:&|.+)?list=([a-zA-Z0-9_-]+))?/,
  },
  {
    //1: VIU All
    name: "VIU All",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:viu\.com\/[a-zA-Z0-9_\/-]+\/video-[a-zA-Z0-9_\/-]+)(?:-([0-9]+))(?:.+playlist-([0-9]+))?/,
  },
  {
    //2: VIU SG, HK, PH, TH, ID
    name: "VIU",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:viu\.com\/ott\/)(?:[a-zA-Z-\/]+)(?:vod\/([0-9]+))/,
  },
  {
    //3: VLive
    name: "VLive",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:vlive\.tv\/(?:video\/|embed\/|post\/[0-9]-))([0-9]+)/,
  },
  {
    //4: Viki
    name: "Viki",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:viki\.com\/videos\/([a-zA-Z0-9]+))/,
  },
  {
    //5: Dailymotion
    name: "Dailymotion",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:(?:dai\.ly\/|dailymotion\.com\/(?:video\/))([a-zA-Z0-9]+))/,
  },
  {
    //6: Vimeo
    name: "Vimeo",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:player\.)?(?:vimeo\.com\/)(?:video\/)?([0-9]+)/,
  },
  {
    //7: Ondemandkorea
    name: "Ondemandkorea",
    regex:
      /^(?:https?:\/\/)?(?:www\.)?ondemandkorea\.com([a-zA-Z0-9-\/]+)\?contentId=([0-9]+)/,
  },
  {
    //8: TED
    name: "TED",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.|embed\.)?(?:ted\.com\/talks\/([a-zA-Z0-9-_]+))/,
  },
  {
    //9: TV.Naver
    name: "TV.Naver",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:tv\.naver\.com\/(?:v\/|embed\/)([0-9]+))/,
  },
  {
    //10: Tv Line
    name: "Youtube",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:tv\.line\.me\/(?:v\/|embed\/)([0-9]+))/,
  },
  {
    //11: Kocowa
    name: "Kocowa",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:kocowa\.com\/(?:(?:[a-z0-9_]+)\/(?:channel|media|video)\/)([0-9]+))/,
  },
  {
    //12: Drive Google
    name: "Drive",
    regex:
      /(?:https?:\/\/)?(?:[\w\-]+\.)*(?:drive|docs)\.google\.com\/(?:(?:folderview|open|uc)\?(?:[\w\-\%]+=[\w\-\%]*&)*id=|(?:folder|file|document|presentation)\/d\/|spreadsheet\/ccc\?(?:[\w\-\%]+=[\w\-\%]*&)*key=)([\w\-]{28,})/i,
  },
  {
    //13: Facebook
    name: "Facebook",
    regex:
      /^(?:https?:\/\/)?(?:www.|web.|m.)?(?:facebook.com.*\/)(?:video(?:s)?|watch|story)(?:\.php)?(?:.+(?:=|\/)([0-9]+))/,
  },
  {
    //14: Vk
    name: "Vk",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:(?:vk\.com|vkvideo\.ru)\/(?:(?:video|feed|hd_kino_mania)\?z=)?(?:video_ext.php\?oid\=|video)([0-9_-]+)(?:&id=([0-9_-]+))?)/,
  },
  {
    //15: Bilibili
    name: "Bilibili",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:bilibili\.(?:tv|com)\/)(?:video\/)([a-zA-Z0-9-]+)/,
  },
  {
    //16: VIU TV
    name: "VIU TV",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:viu\.tv\/encore\/)([a-zA-Z0-9-]+)(?:\/([a-zA-Z0-9-]+))?/,
  },
  {
    //17: TubiTV
    name: "TubiTV",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:tubitv\.com\/(?:video|movies|tv-shows)\/([0-9]+))/,
  },
  {
    //18: Metopera
    name: "Metopera",
    // regex: /^(?:http(?:s)?:\/\/)?(?:www\.|embed\.)?(?:metopera\.org\/season\/(?:[a-zA-Z0-9-_\/]+)\?upc=([0-9]+))/,
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.|embed\.|ondemand\.)?(?:metopera\.org\/performance\/detail\/([a-z0-9-]+))/,
  },
  {
    //19: WeTV Iflix
    name: "WeTV",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:(?:wetv|iflix)\.(?:vip|com)\/)(?:[a-z-]+\/)?(?:play)(?:\?(?:&|.+)?(?:cid=|vid=)([a-z0-9]+)|\/([a-z0-9]+))/,
  },
  {
    //20: Iqiyi Int
    name: "Iqiyi Int",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:iqiyi\.com\/intl|iq\.com)(?:\/play\/)(?:.+-)?([a-zA-Z0-9-]{10,})/,
  },
  {
    //21: Iqiyi Country
    name: "Iqiyi Country",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:iqiyi\.com\/|iq\.com\/)(?:[a-z-]+)(?:\/play\/)(?:.+-)?([a-zA-Z0-9-]{10,})/,
  },
  {
    //22:  LineTV TW
    name: "LineTV TW",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:linetv\.tw\/(?:drama\/|embed\/)((?:[0-9]+)\/eps\/(?:[0-9]+)))/,
  },
  {
    //23: Brightcove
    name: "Brightcove",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:(?:[a-z0-9-]+)\.brightcove(?:-services)?\.(?:com|net|services)\/(?:[^\?&\"'>]+)?\?videoId=([0-9]+))/,
  },
  {
    //24: Iflix
    name: "Iflix",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:iflix\.com\/)(?:[a-z\/]+)(?:movie\/|episode\/|show\/|MOVIE\/|EPISODE\/|SHOW\/)([0-9]+)(?:.+id-downsub=([a-zA-Z0-9]+))?/,
  },
  {
    //25: TV Nrk.no
    name: "Nrk.no",
    regex: /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:tv\.nrk\.no\/)([a-zA-Z0-9\/]+)/,
  },
  {
    //26: Zee5
    name: "Zee5",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:zee5\.com\/)(?:[a-zA-Z0-9-\/]+)(0-[0-9]-[a-z0-9_-]+)/,
  },
  {
    //27: Dimsum
    name: "Dimsum",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:dimsum\.my\/)(?:[a-zA-Z0-9-_\/]+)(?:(?:media|series)-([0-9]+))(?:.+season-downsub=(season-[0-9]+))?/,
  },
  {
    //28: Altbalaji
    name: "Altbalaji",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:altbalaji\.com\/)(?:(?:media|show)(?:[a-zA-Z0-9-\/]+)?\/([0-9]+))(?:.+season-downsub=([0-9]+))?/,
  },
  {
    //29: Voot
    name: "Voot",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:voot\.com\/)(?:[a-zA-Z0-9-_\/]+)(?:(?:[a-z0-9-]+)\/([0-9]+))/,
  },
  {
    //30: Hotstar
    name: "Hotstar",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:hotstar\.com\/)(?:.+?[\/-])?(\d{10}(?=\D*$))/,
  },
  {
    //31: Weverse
    name: "Weverse",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:weverse\.io\/)(?:.+?[\/-])?(?:media\/(\d{4,5}))/,
  },
  {
    //32: Erosnow
    name: "Erosnow",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:erosnow\.com\/)(?:original|movie)\/watch\/(\d{7})\/(?:[a-zA-Z0-9-.]+)(?:\/(\d{7}))?/,
  },
  {
    //33: MGTV
    name: "Mgtv",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:w\.)?(?:mgtv\.com\/b\/)([0-9]+)\/([0-9]+)/,
  },
  {
    //34: Ondemandchina
    name: "Ondemandchina",
    regex:
      /^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:ondemandchina\.com\/)[a-zA-Z0-9-]+\/watch\/([a-zA-Z0-9-]+)\/(movie|ep)-([0-9]+)/,
  },
];

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      downsub: (url: string) => {
        const { $encode } = nuxtApp as any;
        let state = 0;
        let id: string | undefined,
          playlistId: string | undefined,
          source: number | undefined;

        url = url.replace("subtitle.to/", "");
        url = url.replace("Subtitle.to/", "");
        url = url.trim();
        url = decodeURIComponent(url);

        for (let i = 0; i < sourceData.length; i++) {
          const matches = url.match(sourceData[i].regex);
          if (matches && matches.length > 1) {
            id = matches[1];
            state = 1;
            source = i;

            if (i < 2 && matches[2]) {
              playlistId = matches[2];
            }

            if (i === 16 && matches[2]) {
              playlistId = matches[1];
            }

            break;
          }
        }

        return {
          state: state == 1 ? 99 : state,
          url: url,
          urlEncrypt: $encode(url),
          source: source,
          sourceName:
            source !== undefined && source > -1 ? sourceData[source].name : "",
          id: id && $encode(id),
          playlistId,
        };
      },
    },
  };
});
